import utils from '@/mixins/utils.js'

export const dataFieldsPercentual = {
  'N°': 'colocacao',
  CNES: 'nu_cnes',
  UBS: 'no_unidade_saude',
  INE: {
    field: 'nu_ine',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  Equipe: 'no_equipe',
  Nota: 'nota',
  Pontuação: 'resultado',
  Classificação: 'classificacao',
}

export const infoHtml = `
`
